import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/network/:userIdentifier?',
            name: 'network_network',
            component: () => import("./views/network.vue"),
            meta: {
                hasBar: true,
                bottomCutFixed: true,
                routeBuster: true
            }
        },
    ];
};